import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { trigger, style, animate, transition, AnimationEvent, state } from '@angular/animations';
import { SimplebarAngularComponent } from 'simplebar-angular';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { environment } from 'src/environments/environment';
import { DevelopmentsService } from '../../../services/developments.services';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
declare var Swiper: any
declare var Swiper2: any
@Component({
  selector: 'app-visit-reviews-developments',
  templateUrl: './visit-reviews.component.html',
  styleUrls: ['./visit-reviews.component.scss'],
  animations: [
    trigger('changeContent', [
      transition('* <=> *', [
        // style({ opacity: 0, transform: 'scale(0.95)' }),
        // animate('300ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
        style({ opacity: 0, transform: 'translateX(-100px)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ])
    ]),
    trigger('listAnimation', [
      state(
        'full',
        style({
          width: '100%',
        })
      ),
      state(
        'shrunk',
        style({
          width: '50%',
        })
      ),
      transition('full <=> shrunk', [animate('0.5s ease')]),
    ]),
    trigger('detailAnimation', [
      state(
        'hidden',
        style({
          width: '0',
          opacity: 0,
        })
      ),
      state(
        'visible',
        style({
          width: '50%',
          opacity: 1,
        })
      ),
      transition('hidden <=> visible', [animate('0.5s ease')]),
    ]),
  ]
})
export class VisitReviewsDevelopmentsComponent implements OnInit, AfterViewInit {
  private scriptElements: HTMLScriptElement[] = [];
  private linkElements: HTMLLinkElement[] = [];
  @ViewChild('verticalSwiper', { static: false }) verticalSwiper!: ElementRef;
  @ViewChild('verticalSwiper2', { static: false }) verticalSwiper2!: ElementRef;
  private swiper: any;
  @Input()
  property: any
  conteudoAtual: string = 'conteudo1';
  @ViewChild('infiniteScrollBar', { static: false }) simplebar!: SimplebarAngularComponent;
  isLoadMore = false
  isScrollInfinit = false
  selectedItem: any = null;
  offset = 10;
  search = '';
  @ViewChild('pdfContent', { static: false }) pdfContent!: ElementRef;
  @Input()
  propertyReviewData: any
  reviens: { id: number, contactName: string, totalScale: number, obs?: string }[] = []
  @Input()
  propertyAgentsData: any
  pathImage = `${environment.apiUrl}${environment.dirPropertiesImages}/`;
  pathProfileImage = `${environment.apiUrl}/${environment.dirProfileImage}/`;
  private previousScrollTop = 0; // Armazena a posição anterior do scroll
  searchControl = new FormControl('');
  agentMain: any
  @ViewChild('simplebarDatails', { static: false }) simplebarDatails!: SimplebarAngularComponent;
  constructor(private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document, private propertiesService: DevelopmentsService) { }

  ngOnInit(): void {
    this.searchControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe((term: string) => {
      this.search = term;
      this.offset = 0;
      this.previousScrollTop = 0;
      this.reviens = [];
      this.loadMoreItems();
      this.onClose()
    })
    this.initfiles()
    this.reviens = this.propertyReviewData.reviewVisits
    this.agentMain = this.propertyAgentsData.find((ag: any) => ag.isMain)

  }

  ngAfterViewInit() {

  }

  onSelect(item: any) {
    this.resetScroll()
    this.selectedItem = item;
  }

  onClose() {
    this.selectedItem = null;
  }
  resetScroll() {
    if (this.simplebarDatails) {
      // Acessa o elemento de rolagem via o método interno do Simplebar
      const scrollElement = this.simplebarDatails.SimpleBar.getScrollElement();
      if (scrollElement) {
        scrollElement.scrollTop = 0;  // Reseta o scroll ao topo
      }
    }
  }
  onScroll(event: Event) {
    if (this.isLoadMore) {
      // Se estiver carregando, não faz nada.
      return;
    }
    const element = event.target as HTMLElement;
    const scrollTop = element.scrollTop;
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;

    // Verificar se o usuário está rolando para baixo
    const scrolledDown = scrollTop > this.previousScrollTop;

    // Atualiza o previousScrollTop para a próxima checagem
    this.previousScrollTop = scrollTop;

    // Somente carregar mais itens se o usuário estiver rolando para baixo
    if (scrolledDown && (scrollTop + clientHeight >= scrollHeight - 1)) {
      this.loadMoreItems();
    }
  }
  loadMoreItems() {
    if (this.isLoadMore) return;
    this.isLoadMore = true
    this.propertiesService.getAllReviews(this.property.id, this.offset, this.search).subscribe({
      next: (newItems) => {
        if (newItems?.length > 0) {
          this.reviens = [...this.reviens, ...newItems];
          this.offset += 10;
        }
      },
      error: (err) => console.error('Erro ao carregar itens', err),
      complete: () => {
        setTimeout(() => {
          this.isLoadMore = false
        }, 300);
      }
    });

  }

  onSearch(searchTerm: string) {
    this.search = searchTerm;
    // Reiniciar a lista e a paginação
    this.offset = 0;
    this.previousScrollTop = 0;
    this.reviens = [];
    this.loadMoreItems();
  }

  alterarConteudo() {
    this.conteudoAtual = this.conteudoAtual === 'conteudo1' ? 'conteudo2' : 'conteudo1';
    if (this.selectedItem) {
      this.onClose()
    }
  }

  onAnimationDone(event: AnimationEvent) {
    if (this.conteudoAtual === 'conteudo2') {
      this.swiper = undefined
      this.verticalSwiper = undefined!!

      const simplebarInstance = this.simplebar.SimpleBar;

      if (simplebarInstance) {
        const contentElement = simplebarInstance.getScrollElement();
        contentElement.addEventListener('scroll', this.onScroll.bind(this));
      } else {
        console.error('Não foi possível obter a instância do SimpleBar.');
      }
    }
    if (this.conteudoAtual === 'conteudo1' && !this.swiper) {
      if (this.verticalSwiper) {
        this.swiper = new Swiper(this.verticalSwiper.nativeElement, {
          slidesPerView: this.reviens.length >= 3 ? 3 : this.reviens.length == 2 ? 2 : 1,
          spaceBetween: 10,
          mousewheel: true,
          loop: true,
          direction: 'horizontal',
          autoplay: this.reviens.length > 3 ? {
            delay: 2500,
            disableOnInteraction: false,
          } : undefined,
        });
      }
    }
  }

  initfiles() {
    const cssFiles = ['assets/libs/swiper/swiper-bundle.min.css'];
    const jsFiles = ['assets/libs/swiper/swiper-bundle.min.js'];
    // Carregar CSS
    cssFiles.forEach((css) => {
      const linkElement = this.renderer2.createElement('link');
      linkElement.rel = 'stylesheet';
      linkElement.href = css;
      this.renderer2.appendChild(this._document.head, linkElement);
      this.linkElements.push(linkElement);
    });

    // Carregar JS
    jsFiles.forEach((js) => {
      const scriptElement = this.renderer2.createElement('script');
      scriptElement.type = 'text/javascript';
      scriptElement.src = js;
      scriptElement.onload = () => {
        // Código opcional após o carregamento do script
        if (this.verticalSwiper && !this.swiper) {
          this.swiper = new Swiper(this.verticalSwiper.nativeElement, {
            slidesPerView: this.reviens.length >= 3 ? 3 : this.reviens.length == 2 ? 2 : 1,
            spaceBetween: 10,
            mousewheel: true,
            loop: true,
            direction: 'horizontal',
            autoplay: this.reviens.length > 3 ? {
              delay: 2500,
              disableOnInteraction: false,
            } : undefined,
          });
        }

      };
      this.renderer2.appendChild(this._document.body, scriptElement);
      this.scriptElements.push(scriptElement);
    });
  }

  generatePdf() {
    const element = this.pdfContent.nativeElement;
    html2canvas(element, { scale: 2, useCORS: true }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'pt', 'a4');
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      const name = this.property?.reference ? `${this.property?.reference}-reviews.pdf` : 'reviews.pdf';
      pdf.save(name);
    });
  }
  createDateFormat(date: any) {
    const d = new Date(date);
    return d.toLocaleString();
  }
  onImageError(event: any) {
    event.target.src = 'assets/images/no-image-available1_1.jpeg';
  }
  onAgentImageError(event: any) {
    event.target.src = 'assets/images/users/user-dummy-img.jpg';
  }
  ngOnDestroy() {
    // Remover CSS
    this.linkElements.forEach((link) => {
      this.renderer2.removeChild(this._document.head, link);
    });

    // Remover JS
    this.scriptElements.forEach((script) => {
      this.renderer2.removeChild(this._document.body, script);
    });
  }
}
